import {Registrar} from '../types';

import {
    useCreateRegistrarMutation,
    useDeleteRegistrarMutation,
    useRegistrarQuery,
    useUpdateRegistrarMutation,
} from './useRegistrarsQuery';

// FNP-943: the single record comes from React Query. Return shape unchanged so
// the pages and forms consuming this hook did not change.
export const useRegistrar = (registrarId?: string) => {

    const {
        data: record,
        isLoading,
        refetch
    } = useRegistrarQuery(registrarId);

    const createMutation = useCreateRegistrarMutation();
    const updateMutation = useUpdateRegistrarMutation();
    const deleteMutation = useDeleteRegistrarMutation();

    // FETCH
    const fetchRecord = () => {
        if (typeof registrarId === 'undefined') {
            throw new Error('registrarId is required parameter');
        }
        refetch();
    };

    // CREATE, UPDATE, DELETE
    const createRecord = (values: Registrar) => {
        createMutation.mutate(values);
    };

    const updateRecord = (values: Registrar) => {
        if (typeof registrarId === 'undefined') {
            throw new Error('registrarId is required parameter');
        }
        updateMutation.mutate({
            id: registrarId,
            record: values,
        });
    };

    const deleteRecord = () => {
        if (typeof registrarId === 'undefined') {
            throw new Error('registrarId is required parameter');
        }
        deleteMutation.mutate(registrarId);
    };

    return {
        record,
        loading: isLoading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
